const emojis = [
  {
    file: 'emoji_1.png',
    code: '/::)',
    title: '微笑',
    reg: /\/::\)/g
  },
  {
    file: 'emoji_2.png',
    code: '/::~',
    title: '撇嘴',
    reg: /\/::~/g
  },
  {
    file: 'emoji_3.png',
    code: '/::B',
    title: '色',
    reg: /\/::B/g
  },
  {
    file: 'emoji_4.png',
    code: '/::|',
    title: '发呆',
    reg: /\/::\|/g
  },
  {
    file: 'emoji_5.png',
    code: '/:8-)',
    title: '得意',
    reg: /\/:8-\)/g
  },
  {
    file: 'emoji_6.png',
    code: '/::<',
    title: '流泪',
    reg: /\/::</g
  },
  {
    file: 'emoji_7.png',
    code: '/::$',
    title: '害羞',
    reg: /\/::\$/g
  },
  {
    file: 'emoji_8.png',
    code: '/::X',
    title: '闭嘴',
    reg: /\/::X/g
  },
  {
    file: 'emoji_9.png',
    code: '/::Z',
    title: '睡',
    reg: /\/::Z/g
  },
  {
    file: 'emoji_10.png',
    code: '/::\'(',
    title: '大哭',
    reg: /\/::'\(/g
  },
  {
    file: 'emoji_11.png',
    code: '/::-|',
    title: '尴尬',
    reg: /\/::-\|/g
  },
  {
    file: 'emoji_12.png',
    code: '/::@',
    title: '发怒',
    reg: /\/::@/g
  },
  {
    file: 'emoji_13.png',
    code: '/::P',
    title: '调皮',
    reg: /\/::P/g
  },
  {
    file: 'emoji_14.png',
    code: '/::D',
    title: '呲牙',
    reg: /\/::D/g
  },
  {
    file: 'emoji_15.png',
    code: '/::O',
    title: '惊讶',
    reg: /\/::O/g
  },
  {
    file: 'emoji_16.png',
    code: '/::(',
    title: '难过',
    reg: /\/::\(/g
  },
  {
    file: 'emoji_17.png',
    code: '[囧]',
    title: '囧',
    reg: /\[囧]\+/g
  },
  {
    file: 'emoji_18.png',
    code: '/::Q',
    title: '抓狂',
    reg: /\/::Q/g
  },
  {
    file: 'emoji_19.png',
    code: '/::T',
    title: '吐',
    reg: /\/::T/g
  },
  {
    file: 'emoji_20.png',
    code: '/:,@P',
    title: '偷笑',
    reg: /\/:,@P/g
  },
  {
    file: 'emoji_21.png',
    code: '/:,@-D',
    title: '愉快',
    reg: /\/:,@-D/g
  },
  {
    file: 'emoji_22.png',
    code: '/::d',
    title: '白眼',
    reg: /\/::d/g
  },
  {
    file: 'emoji_23.png',
    code: '/:,@o',
    title: '傲慢',
    reg: /\/:,@o/g
  },
  {
    file: 'emoji_24.png',
    code: '/:|-)',
    title: '困',
    reg: /\/:\|-\)/g
  },
  {
    file: 'emoji_25.png',
    code: '/::!',
    title: '惊恐',
    reg: /\/::!/g
  },
  {
    file: 'emoji_26.png',
    code: '/::L',
    title: '流汗',
    reg: /\/::L/g
  },
  {
    file: 'emoji_27.png',
    code: '/::>',
    title: '憨笑',
    reg: /\/::>/g
  },
  {
    file: 'emoji_28.png',
    code: '/::,@',
    title: '悠闲',
    reg: /\/::,@/g
  },
  {
    file: 'emoji_29.png',
    code: '/:,@f',
    title: '奋斗',
    reg: /\/:,@f/g
  },
  {
    file: 'emoji_30.png',
    code: '/::-S',
    title: '咒骂',
    reg: /\/::-S/g
  },
  {
    file: 'emoji_31.png',
    code: '/:?',
    title: '疑问',
    reg: /\/:?/g
  },
  {
    file: 'emoji_32.png',
    code: '/:,@x',
    title: '嘘',
    reg: /\/:,@x/g
  },
  {
    file: 'emoji_33.png',
    code: '/:,@@',
    title: '晕',
    reg: /\/:,@@/g
  },
  {
    file: 'emoji_34.png',
    code: '/:,@!',
    title: '衰',
    reg: /\/:,@!/g
  },
  {
    file: 'emoji_35.png',
    code: '/:!!!',
    title: '骷髅',
    reg: /\/:!!!/g
  },
  {
    file: 'emoji_36.png',
    code: '/:xx',
    title: '敲打',
    reg: /\/:xx/g
  },
  {
    file: 'emoji_37.png',
    code: '/:bye',
    title: '再见',
    reg: /\/:bye/g
  },
  {
    file: 'emoji_38.png',
    code: '/:wipe',
    title: '擦汗',
    reg: /\/:wipe/g
  },
  {
    file: 'emoji_39.png',
    code: '/:dig',
    title: '抠鼻',
    reg: /\/:dig/g
  },
  {
    file: 'emoji_40.png',
    code: '/:handclap',
    title: '鼓掌',
    reg: /\/:handclap/g
  },
  {
    file: 'emoji_41.png',
    code: '/:B-)',
    title: '坏笑',
    reg: /\/:B-\)/g
  },
  {
    file: 'emoji_42.png',
    code: '/:<@',
    title: '左哼哼',
    reg: /\/:<@/g
  },
  {
    file: 'emoji_43.png',
    code: '/:@>',
    title: '右哼哼',
    reg: /\/:@>/g
  },
  {
    file: 'emoji_44.png',
    code: '/::-O',
    title: '哈欠',
    reg: /\/::-O/g
  },
  {
    file: 'emoji_45.png',
    code: '/:>-|',
    title: '鄙视',
    reg: /\/:>-\|\)/g
  },
  {
    file: 'emoji_46.png',
    code: '/:P-(',
    title: '委屈',
    reg: /\/:P-\(/g
  },
  {
    file: 'emoji_47.png',
    code: "/::'|",
    title: '快哭了',
    reg: /\/::'|/g
  },
  {
    file: 'emoji_48.png',
    code: '/:X-)',
    title: '阴险',
    reg: /\/:X-\)/g
  },
  {
    file: 'emoji_49.png',
    code: '/::*',
    title: '亲亲',
    reg: /\/::*/g
  },
  {
    file: 'emoji_50.png',
    code: '/:8*',
    title: '可怜',
    reg: /\/:8*/g
  },
  {
    file: 'emoji_51.png',
    code: '/:pd',
    title: '菜刀',
    reg: /\/:pd/g
  },
  {
    file: 'emoji_52.png',
    code: '/:<W>',
    title: '西瓜',
    reg: /\/:<W>/g
  },
  {
    file: 'emoji_53.png',
    code: '/:beer',
    title: '啤酒',
    reg: /\/:beer/g
  },
  {
    file: 'emoji_54.png',
    code: '/:coffee',
    title: '咖啡',
    reg: /\/:coffee/g
  },
  {
    file: 'emoji_55.png',
    code: '/:pig',
    title: '猪头',
    reg: /\/:pig/g
  },
  {
    file: 'emoji_56.png',
    code: '/:rose',
    title: '玫瑰',
    reg: /\/:rose/g
  },
  {
    file: 'emoji_57.png',
    code: '/:fade',
    title: '凋谢',
    reg: /\/:fade/g
  },
  {
    file: 'emoji_58.png',
    code: '/:showlove',
    title: '嘴唇',
    reg: /\/:showlove/g
  },
  {
    file: 'emoji_59.png',
    code: '/:heart',
    title: '爱心',
    reg: /\/:heart/g
  },
  {
    file: 'emoji_60.png',
    code: '/:break',
    title: '心碎',
    reg: /\/:break/g
  },
  {
    file: 'emoji_61.png',
    code: '/:cake',
    title: '蛋糕',
    reg: /\/:cake/g
  },
  {
    file: 'emoji_62.png',
    code: '/:bome',
    title: '炸弹',
    reg: /\/:bome/g
  },
  {
    file: 'emoji_63.png',
    code: '/:shit',
    title: '便便',
    reg: /\/:shit/g
  },
  {
    file: 'emoji_64.png',
    code: '/:moon',
    title: '月亮',
    reg: /\/:moon/g
  },
  {
    file: 'emoji_65.png',
    code: '/:sun',
    title: '太阳',
    reg: /\/:sun/g
  },
  {
    file: 'emoji_66.png',
    code: '/:hug',
    title: '拥抱',
    reg: /\/:hug/g
  },
  {
    file: 'emoji_67.png',
    code: '/:strong',
    title: '强',
    reg: /\/:strong/g
  },
  {
    file: 'emoji_68.png',
    code: '/:weak',
    title: '弱',
    reg: /\/:weak/g
  },
  {
    file: 'emoji_69.png',
    code: '/:share',
    title: '握手',
    reg: /\/:share/g
  },
  {
    file: 'emoji_70.png',
    code: '/:v',
    title: '胜利',
    reg: /\/:v/g
  },
  {
    file: 'emoji_71.png',
    code: '/:@)',
    title: '抱拳',
    reg: /\/:@\)/g
  },
  {
    file: 'emoji_72.png',
    code: '/:jj',
    title: '勾引',
    reg: /\/:jj/g
  },
  {
    file: 'emoji_73.png',
    code: '/:@@',
    title: '拳头',
    reg: /\/:@@/g
  },
  {
    file: 'emoji_74.png',
    code: '/:ok',
    title: 'OK',
    reg: /\/:ok/g
  },
  {
    file: 'emoji_75.png',
    code: '[笑脸]',
    title: '笑脸',
    reg: /\/:笑脸/g,
    emojiFlag: true,
    emoji: '😄'
  },
  {
    file: 'emoji_76.png',
    code: '[生病]',
    title: '生病',
    reg: /\/:生病/g,
    emojiFlag: true,
    emoji: '😷'
  },
  {
    file: 'emoji_77.png',
    code: '[笑哭]',
    title: '笑哭',
    reg: /\/:笑哭/g,
    emojiFlag: true,
    emoji: '😂'
  },
  {
    file: 'emoji_78.png',
    code: '[鬼脸]',
    title: '鬼脸',
    reg: /\/:鬼脸/g,
    emojiFlag: true,
    emoji: '😝'
  },
  {
    file: 'emoji_79.png',
    code: '[脸红]',
    title: '脸红',
    reg: /\/:脸红/g,
    emojiFlag: true,
    emoji: '😳'
  },
  {
    file: 'emoji_80.png',
    code: '[恐怖]',
    title: '恐怖',
    reg: /\/:恐怖/g,
    emojiFlag: true,
    emoji: '😱'
  },
  {
    file: 'emoji_81.png',
    code: '[叹气]',
    title: '叹气',
    reg: /\/:叹气/g,
    emojiFlag: true,
    emoji: '😔'
  },
  {
    file: 'emoji_82.png',
    code: '[斜眼]',
    title: '斜眼',
    reg: /\/:斜眼/g,
    emojiFlag: true,
    emoji: '😒'
  },
  {
    file: 'emoji_83.png',
    code: '[Hey]',
    title: 'Hey',
    reg: /\[Hey]/g
  },
  {
    file: 'emoji_84.png',
    code: '[Facepalm]',
    title: 'Facepalm',
    reg: /\[Facepalm]/g
  },
  {
    file: 'emoji_85.png',
    code: '[Smirk]',
    title: 'Smirk',
    reg: /\[Smirk]/g
  },
  {
    file: 'emoji_86.png',
    code: '[Smart]',
    title: 'Smart',
    reg: /\[Smart]/g
  },
  {
    file: 'emoji_87.png',
    code: '[Concerned]',
    title: 'Concerned',
    reg: /\[Concerned]/g
  },
  {
    file: 'emoji_88.png',
    code: '[Yeah!]',
    title: 'Yeah!',
    reg: /\[Yeah!]/g
  },
  {
    file: 'emoji_89.png',
    code: '[吃瓜]',
    title: '吃瓜',
    reg: /\[吃瓜]/g
  },
  {
    file: 'emoji_90.png',
    code: '[加油]',
    title: '加油',
    reg: /\[加油]/g
  },
  {
    file: 'emoji_91.png',
    code: '[汗]',
    title: '汗',
    reg: /\[汗]/g
  },
  {
    file: 'emoji_92.png',
    code: '[天啊]',
    title: '天啊',
    reg: /\[天啊]/g
  },
  {
    file: 'emoji_93.png',
    code: '[Emm]',
    title: 'Emm',
    reg: /\[Emm]/g
  },
  {
    file: 'emoji_94.png',
    code: '[社会社会]',
    title: '社会社会',
    reg: /\[社会社会]/g
  },
  {
    file: 'emoji_95.png',
    code: '[旺柴]',
    title: '旺柴',
    reg: /\[旺柴]/g
  },
  {
    file: 'emoji_96.png',
    code: '[好的]',
    title: '好的',
    reg: /\[好的]/g
  },
  {
    file: 'emoji_97.png',
    code: '[打脸]',
    title: '打脸',
    reg: /\[打脸]/g
  },
  {
    file: 'emoji_98.png',
    code: '[加油加油]',
    title: '加油加油',
    reg: /\[加油加油]/g
  },
  {
    file: 'emoji_99.png',
    code: '[哇]',
    title: '哇',
    reg: /\[哇]/g
  },
  {
    file: 'emoji_100.png',
    code: '[幽灵]',
    title: '幽灵',
    reg: /\[幽灵]/g,
    emojiFlag: true,
    emoji: '👻'
  },
  {
    file: 'emoji_101.png',
    code: '[祈祷]',
    title: '祈祷',
    reg: /\[祈祷]/g,
    emojiFlag: true,
    emoji: '🙏'
  },
  {
    file: 'emoji_102.png',
    code: '[肌肉]',
    title: '肌肉',
    reg: /\[肌肉]/g,
    emojiFlag: true,
    emoji: '💪'
  },
  {
    file: 'emoji_103.png',
    code: '[庆祝]',
    title: '庆祝',
    reg: /\[庆祝]/g,
    emojiFlag: true,
    emoji: '🎉'
  },
  {
    file: 'emoji_104.png',
    code: '[礼物]',
    title: '礼物',
    reg: /\[礼物]/g,
    emojiFlag: true,
    emoji: '🎁'
  },
  {
    file: 'emoji_105.png',
    code: '[Packet]',
    title: 'Packet',
    reg: /\[Packet]/g
  },

  {
    file: 'emoji_106.png',
    code: '[發]',
    title: '發',
    reg: /\[發]/g
  },
  {
    file: 'emoji_107.png',
    code: '[Blessing]',
    title: 'Blessing',
    reg: /\[Blessing]/g
  }
]

/**
 * 将输入的聊天框的表情code转化为图片
 *再经过v-html 渲染成真正的图片
* */
function replaceEmoji(con) {
  for (let i = 0; i < emojis.length; i++) {
    const item = emojis[i]
    if (con === item.title) {
      const imgSrc = require('../../assets/emoji2/' + item.file)
      con = '<img src="' + imgSrc + '"  alt="[' + item.title + ']"  style="vertical-align: middle; width: 24px; height: 24px" />'
      break
    }
  }
  return con
  // }
  // return con
}

/**
 * 将要发送的内容的表情<img>标签转化为[title]
 * */
function imageToTitle(content) {
  // const reg = /<img\b.*?(?:\>|\/>)/ig // 匹配img标签
  let res = content
  const arr = content.match(/<img.*?src=[\"|\']?(.*?)[\"|\']?\s.*?>/ig) || []
  if (!arr || arr.length === 0) {
    return res
  }
  if (arr && arr.length > 0) {
    arr.forEach(item => {
      if (item.indexOf('data-title=') > -1) {
        const title = `${item.split('data-title=')[1].split('" ')[0].split('"')[1]}`
        res = res.replace(item, `[${title}]`)
      }
      if (item.indexOf('alert=') > -1) {
        const title = `${item.split('alert=')[1].split('" ')[0].split('"')[1]}`
        res = res.replace(item, `[${title}]`)
      }
    })
    return res
  }
}
/**
 * 解析聊天内容的表情，解析已发送出去的聊天内容
* */
const emoji = [
  { value: '😄', title: '笑脸' },
  { value: '😷', title: '生病' },
  { value: '😂', title: '笑哭' },
  { value: '😝', title: '鬼脸' },
  { value: '😳', title: '脸红' },
  { value: '😱', title: '恐怖' },
  { value: '😔', title: '叹气' },
  { value: '😒', title: '斜眼' },
  { value: '👻', title: '幽灵' },
  { value: '🙏', title: '祈祷' },
  { value: '💪', title: '肌肉' },
  { value: '🎉', title: '庆祝' },
  { value: '🎁', title: '礼物' }
]

function toEmoji(value) {
  let newValue = toOriginEmoji(value)
  // 将微信端的表情内容转化成文本的表情内容
  emoji.forEach(item => {
    if (newValue && newValue.includes(item.value)) {
      newValue = newValue.split(item.value).join(`[${item.title}]`)
    }
  })
  // 将表情内容变成数组
  const emojiArrMatch = newValue.match(/\[.*?]/ig) || []
  const len = emojiArrMatch && emojiArrMatch.length || 0
  if (len > 0) {
    // [[哭],[笑]]表情内容数组变成图片显示
    emojiArrMatch.forEach((item, index) => {
      if (index > 99) {
        return item
      }
      const url = getEmoji(item)
      const img = `<img data-title=${item.split('[')[1].split(']')[0]} src=${url} style="background: transparent;vertical-align: middle; width: 24px; height: 24px;">`
      newValue = newValue.replace(item, img)
    })
  }

  // 将url转化为a标签
  newValue = changeUrl(newValue)
  return newValue
}

var emojiArr = []
var emojiNum = emojis.length

for (let i = 0; i < emojiNum; i++) {
  const url = require(`../../assets/emoji2/emoji_${i + 1}.png`)
  emojiArr.push({
    url: url,
    title: `[${emojis[i].title}]`
  })
}
// 接收到的字符串与命名好的emoji字符串匹配
const getEmoji = (title) => {
  for (let i = 0; i < emojiNum; i++) {
    if (title === emojiArr[i].title) {
      return emojiArr[i].url
    }
  }
}

/**
 * 将自定义的，较友好的表情字符转换为原生的字符
 *
 * [鼓掌] => /:handclap
 * @param {String} con 内容
 */
function toOriginEmoji(con) {
  if (con && con.includes('/:')) {
    for (var i = 0; i < emojis.length; i++) {
      const item = emojis[i]
      // 自定义的格式，样例: [鼓掌(/:handclap)]
      const reg = `${item.code}`
      con = con.split(reg).join(`[${item.title}]`)
    }
    return con
  }
  return con
}

/**
 * 将图片 => /:handclap
 * @param {String} con 内容
 */
function toOriginEmojiFromImg(con) {
  if (con && con.includes('<img')) {
    const conArr = con.match(/<img[^>]*>/ig)
    let conNew = con
    conArr.forEach((val) => {
      const emojiTitle = val.split(' alt="')[1].split('" style')[0]
      conNew = conNew.split(val).join(changeTitleToCode(emojiTitle))
    })
    return conNew
  }
  return con.replace(/<br>|<\/br>/, '')
    .replace(/<div>|<p>/g, '\r\n')
    .replace(/<\/div>|<\/p>/g, '')
}
function changeTitleToCode(title) {
  for (let k = 0; k < emojis.length; k++) {
    if (title === emojis[k].title) {
      return emojis[k].code
    }
  }
}

// 识别url,替换成连接
function changeUrl(newValue) {
  // 正规连接正则
  const linkToRegular = /((https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%?=~_|!:,.;])|(([-A-Za-z0-9+&@#/%?=~_|!:,.;])+\.((cn\/)|(com\/)|cn|com))/ig
  const reg = new RegExp(linkToRegular)
  if (reg.test(newValue)) {
    const matchcon = newValue.match(linkToRegular)
    matchcon.forEach(item => {
      const url = item.indexOf('http') > -1 ? item : 'https://' + item
      newValue = newValue.replace(item, `<a style=" color:rgba(0,0,238,1); line-height:1.18vw; font-size:12px; font-weight:400; font-family:PingFangSC-Regular,PingFang SC;" target="blank" href="${url}">${item}</a>`)
    })
  }

  return newValue
}

export {
  emojis,
  toEmoji,
  imageToTitle,
  replaceEmoji,
  toOriginEmoji,
  toOriginEmojiFromImg
}
